
<div class="trust-and-safety-sign-up">
  <p class="px-16 py-16">
    All users are encouraged to visit our
    <a class="underline" target="_blank" href="https://www.sittercity.com/trust-and-safety">Trust & Safety Center</a>
    to learn more about our commitment to keeping you safe.
  </p>
</div>
